import React, { useEffect, useState } from "react";

function BurgerMenu({
  showNavbar = true,
  mode = "blue",
  onHandleScroll,
}: {
  showNavbar?: boolean;
  mode?: "white" | "blue";
  onHandleScroll: (event: any, sectionId: any) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(showNavbar);

  useEffect(() => {
    // Trigger the fade-in effect when the navbar becomes visible
    if (showNavbar) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50); // Adjust time for fade-in delay
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false); // Reset visibility when navbar is not shown
    }
  }, [showNavbar]);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  if (!showNavbar) return null; // Hide the navbar completely when showNavbar is false

  return (
    <nav
      className={`md:hidden sticky top-0 transition-opacity duration-500 ease-in-out ${
        isVisible ? "opacity-100" : "opacity-0"
      } ${
        mode === "blue" ? "bg-dark-blue" : "bg-white border-b border-gray-200"
      }`}
      style={{ zIndex: 3 }}
    >
      {/* Top bar: logo on left, burger icon on right */}
      <div className="flex items-center justify-between px-4 py-2">
        {/* Logo */}
        <div className="flex flex-col-reverse items-start justify-end space-x-2">
          {/* Replace with your actual logo/image */}
          <img
            src={
              mode === "blue"
                ? "/assets/logo/logoBardh.svg"
                : "/assets/logo/LOGOSVG.svg"
            }
            alt="Logo"
            loading="lazy"
            className="w-48 h-10"
          />
          <div className="flex flex-row justify-between w-full gap-4">
            {/* <img
                src={"/assets/icons/phone.svg"}
                alt="Logo"
                className="size-2"
              /> */}
            {/* <a href="tel:+41764727563" className="flex">
              ✆: +41 76 472 75 63
            </a>
            <a href="mailto:kontakt@fahrschul-kurse.ch">
              📧: kontakt@fahrschul-kurse.ch
            </a> */}
          </div>
        </div>

        {/* Burger Icon */}
        <button
          type="button"
          className={`md:hidden p-2 hover:text-gray-900 focus:outline-none ${
            mode === "blue"
              ? "text-white hover:text-gray-400 transition-opacity"
              : "text-gray-700"
          }`}
          onClick={handleToggle}
        >
          {isOpen ? (
            <img
              src={"/assets/icons/x.svg"}
              loading="lazy"
              alt="Logo"
              className={`size-6 ${
                mode === "blue" ? "filter invert" : "text-black"
              }`}
            />
          ) : (
            <img
              src={"/assets/icons/burgerMenu.svg"}
              loading="lazy"
              alt="Logo"
              className={`size-6 ${
                mode === "blue" ? "filter invert" : "text-black"
              }`}
            />
          )}
        </button>
      </div>

      {/* Collapsible Nav (mobile) */}
      {/* The nav will have smooth height transition based on `isOpen` */}
      <div
        className={`md:flex md:items-center md:static md:max-h-full md:mt-0 overflow-hidden transition-all duration-300 ease-in-out px-4 ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <ul
          className={`md:flex md:space-x-6 space-y-2 md:space-y-0 py-2  md:py-0 w-full ${
            mode === "blue" ? "text-white" : "text-gray-700"
          }`}
        >
          <li>
            <a
              onClick={(e) => {
                handleToggle();
                onHandleScroll(e, "Home");
              }}
              className={`block cursor-pointer py-1 px-2 rounded ${
                mode === "blue"
                  ? "hover:bg-blue-900 hover:text-gray-200 transition-opacity"
                  : "hover:bg-gray-100"
              }  transition`}
            >
              – Startseite
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                handleToggle();
                onHandleScroll(e, "Info");
              }}
              className={`block cursor-pointer py-1 px-2 rounded ${
                mode === "blue"
                  ? "hover:bg-blue-900 hover:text-gray-200 transition-opacity"
                  : "hover:bg-gray-100"
              } transition`}
            >
              – Anmelden
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                handleToggle();
                onHandleScroll(e, "Location");
              }}
              className={`block cursor-pointer py-1 px-2 rounded ${
                mode === "blue"
                  ? "hover:bg-blue-900 hover:text-gray-200 transition-opacity"
                  : "hover:bg-gray-100"
              } transition`}
            >
              – Standort
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                handleToggle();
                onHandleScroll(e, "FAQ");
              }}
              className={`block cursor-pointer py-1 px-2 rounded ${
                mode === "blue"
                  ? "hover:bg-blue-900 hover:text-gray-200 transition-opacity"
                  : "hover:bg-gray-100"
              } transition`}
            >
              – FAQ
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                handleToggle();
                onHandleScroll(e, "ContactUs");
              }}
              className={`block cursor-pointer py-1 px-2 rounded ${
                mode === "blue"
                  ? "hover:bg-blue-900 hover:text-gray-200 transition-opacity"
                  : "hover:bg-gray-100"
              } transition`}
            >
              – Kontakt
            </a>
          </li>
        </ul>
        <div
          className={`flex w-full gap-10 max-sm:flex-col max-sm:gap-2 pb-2 ${
            mode === "blue" ? "text-white" : "text-black"
          }`}
        >
          <a href="tel:+41764727563" className="flex">
            {/* <img
                src={"/assets/icons/phone.svg"}
                alt="Logo"
                className="size-2"
              /> */}
            ✆: +41 76 472 75 63
          </a>
          <a href="mailto:lumifahrschule@gmail.com">
            📧: lumifahrschule@gmail.com
          </a>
        </div>
      </div>
    </nav>
  );
}

export default BurgerMenu;
